export default __webpack_public_path__ + "img/54893ff7.jpg";